import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "28",
  height: "28",
  fill: "none",
  viewBox: "0 0 28 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#74BB11",
      d: "M21.913 4.553A.98.98 0 0 0 20.99 4h-1.609c-.468 0-.814.192-1.001.536L16.294 7.65a.76.76 0 0 0 .013.866l1.142 1.598c.308.43.95.423 1.248-.013l3.031-4.432c.4-.495.262-.944.185-1.117"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#009CD9",
      d: "M9.422 4.474A1.19 1.19 0 0 0 8.42 4H6.86a.98.98 0 0 0-.9.492c-.175.32-.134.706.106 1.063l5.452 7.388a.76.76 0 0 1 .001.903l-6.32 8.62a.97.97 0 0 0-.09 1.04c.18.317.528.507.899.492h1.597c.394.007.76-.2.95-.537l7.11-9.579a.76.76 0 0 0 .001-.904z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#EB2084",
      d: "m22.87 22.525-4.225-5.693a.76.76 0 0 0-1.227.005l-1.084 1.488a.76.76 0 0 0 .011.91l3.533 4.623.095.04c.145.066.302.1.46.101h1.55a1 1 0 0 0 .874-.454 1.02 1.02 0 0 0 .013-1.02"
    }, null, -1)
  ]))]))
}
export default { render: render }